import React, { useRef, useCallback, useEffect, useState } from "react";
import { useSpring, animated } from "react-spring";
import { Background, ModalContent, CloseModalButton, Button, InputLabel } from "../../ModalRegisterStyle";
import Swal from "sweetalert2";
import api from "../../../../services/api";

export default function ImportExcel({ showModal, setShowModal, recarregaTabela }) {
  const modalRef = useRef();
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (
      selectedFile?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      selectedFile?.type === "application/vnd.ms-excel"
    ) {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
    } else if (selectedFile) {
      Swal.fire("Erro", "Por favor, selecione um arquivo do tipo .xlsx.", "error");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (
      droppedFile?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      droppedFile?.type === "application/vnd.ms-excel"
    ) {
      setFile(droppedFile);
      setFileUrl(URL.createObjectURL(droppedFile));
    } else if (droppedFile) {
      Swal.fire("Erro", "Por favor, arraste um arquivo do tipo .xlsx.", "error");
    }
    setDragActive(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleImportaExcel = async () => {
    if (!file) {
      Swal.fire("Atenção", "Selecione um arquivo .xlsx antes de importar.", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("xlsx", file);

    setLoading(true);
    try {
      const response = await api.post("/rh/controle-cestas/carregar-dados", formData);
      Swal.fire("Sucesso", "Arquivo importado com sucesso.", "success");
      setShowModal(false);
    } catch (error) {
      console.error("Erro ao importar o arquivo:", error);
      Swal.fire("Atenção!", "Erro ao importar o arquivo.", "error");
    } finally {
      setLoading(false);
      recarregaTabela();
    }
  };

  return (
    <>
      {showModal ? (
        loading ? (
          <Background>
            <animated.div>
              <ModalContent>
                <p>Carregando excel...</p>
              </ModalContent>
            </animated.div>
          </Background>
        ) : (
          <Background
            ref={modalRef}
            onClick={(e) => {
              if (modalRef.current === e.target) {
                setShowModal(false);
              }
            }}
          >
            <animated.div style={animation}>
              <ModalContent>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleImportaExcel();
                  }}
                >
                  <InputLabel>
                    <label
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      Anexo .xlsx
                    </label>

                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      style={{
                        width: "700px",
                        minHeight: "120px",
                        border: dragActive ? "2px dashed #007bff" : "2px dashed #ccc",
                        borderRadius: "8px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                        backgroundColor: dragActive ? "#f0f8ff" : "#fafafa",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        position: "relative",
                      }}
                      onClick={() => document.getElementById("excel-input").click()}
                    >
                      <input id="excel-input" type="file" accept=".xlsx, .xls" onChange={handleFileChange} style={{ display: "none" }} />

                      {file ? (
                        <div style={{ textAlign: "center", width: "100%" }}>
                          <div style={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px", color: "#333" }}>{file.name}</div>
                          <div style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>
                            Tamanho: {(file.size / 1024 / 1024).toFixed(2)} MB
                          </div>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setFile(null);
                              setFileUrl(null);
                            }}
                            style={{
                              padding: "8px 20px",
                              backgroundColor: "#dc3545",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            Remover
                          </button>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", color: "#666" }}>
                          {dragActive ? "Solte o arquivo .xlsx aqui" : "Arraste ou clique para enviar um arquivo .xlsx"}
                        </div>
                      )}
                    </div>
                  </InputLabel>
                  <Button type="submit">Importar Dados</Button>
                </form>
                <CloseModalButton onClick={() => setShowModal(false)} />
              </ModalContent>
            </animated.div>
          </Background>
        )
      ) : null}
    </>
  );
}
